module.exports = __webpack_public_path__ + "img/chemical.9f1c082b.svg";